module.exports = __webpack_public_path__ + "img/section_2@2x.8c16af12.png";